import React from 'react';
import { Box } from '@material-ui/core';
import { createSvgIcon } from '@material-ui/core/utils';

import { range } from '../utils/generalLib';

export const StitchIcon =
  createSvgIcon(
    <svg
      viewBox="-100 -100 1227 1224"
    >
      <path
        d="M962.56 170.666667l37.546667-34.133334c30.72-30.72 30.72-81.92 0-116.053333-30.72-30.72-85.333333-30.72-116.053334 0L843.093333 68.266667c-105.813333-58.026667-211.626667-68.266667-310.613333-68.266667-150.186667 0-232.106667 75.093333-232.106667 211.626667 0 153.6 150.186667 266.24 157.013334 273.066666 3.413333 3.413333 6.826667 3.413333 6.826666 3.413334L3.413333 996.693333c-6.826667 6.826667-6.826667 17.066667 0 23.893334 3.413333 3.413333 10.24 3.413333 13.653334 3.413333 3.413333 0 6.826667 0 10.24-3.413333L546.133333 549.546667c17.066667 13.653333 40.96 27.306667 64.853334 40.96 85.333333 54.613333 204.8 129.706667 204.8 201.386666 0 95.573333-85.333333 197.973333-327.68 197.973334-10.24 0-17.066667 6.826667-17.066667 17.066666s6.826667 17.066667 17.066667 17.066667c266.24 0 361.813333-126.293333 361.813333-232.106667 0-88.746667-122.88-167.253333-221.866667-228.693333-20.48-13.653333-40.96-27.306667-58.026666-37.546667l365.226666-331.093333C972.8 238.933333 989.866667 283.306667 989.866667 317.44c0 95.573333-37.546667 146.773333-112.64 153.6-10.24 0-17.066667 10.24-13.653334 20.48 0 10.24 6.826667 13.653333 17.066667 13.653333h3.413333c92.16-10.24 143.36-78.506667 143.36-187.733333C1024 273.066667 1003.52 225.28 962.56 170.666667z m-30.72-78.506667c6.826667 6.826667 6.826667 17.066667 0 23.893333l-10.24 10.24c-3.413333-3.413333-6.826667-6.826667-10.24-13.653333-6.826667-6.826667-17.066667-6.826667-23.893333 0l20.48-20.48c6.826667-6.826667 17.066667-6.826667 23.893333 0zM477.866667 453.973333s-143.36-109.226667-143.36-245.76C334.506667 64.853333 443.733333 34.133333 532.48 34.133333c92.16 0 191.146667 6.826667 286.72 61.44l-334.506667 372.053334c0-6.826667-3.413333-10.24-6.826666-13.653334z m413.013333-296.96c-3.413333 3.413333-6.826667 3.413333-13.653333 3.413334s-10.24 0-13.653334-3.413334c-6.826667-6.826667-6.826667-17.066667 0-23.893333l23.893334-20.48c-6.826667 6.826667-6.826667 17.066667 0 23.893333 3.413333 3.413333 6.826667 6.826667 10.24 13.653334l-6.826667 6.826666z"
      />
    </svg>
  );

export const S3Icon =
  createSvgIcon(
    <svg
      viewBox="0 0 512.002 512.002"
    >
      <path
        d="M392.566,159.4c-0.649-79.601-31.851-134.481-80.25-141.944l-1.443-10.127c-0.324-2.246-1.52-4.261-3.339-5.619 c-1.81-1.358-4.09-1.947-6.327-1.622l-92.99,13.287c-4.671,0.666-7.916,4.995-7.25,9.666l1.605,11.229 c-0.709,0.179-1.417,0.307-2.075,0.692c-52.122,30.126-68.688,71.677-77.346,122.859c-34.293,13.773-55.008,33.157-55.008,55.316 c0,11.997,6.242,23.149,17.24,33.072c-0.12,0.922,42.712,207.763,42.712,207.763c0.06,0.273,0.128,0.555,0.213,0.828 c10.64,33.678,63.146,57.203,127.693,57.203c66.963,0,118.308-23.107,127.906-58.031c0,0,42.832-206.841,42.712-207.763 c10.998-9.922,17.24-21.074,17.24-33.072C443.86,191.797,424.595,173.054,392.566,159.4z M116.285,210.472 c-1.221,10.887-2.545,22.167-4.022,33.712c-17.326-9.606-27.043-20.545-27.043-31.048c0-11.989,12.723-24.541,34.933-35.044 C118.779,188.544,117.541,199.311,116.285,210.472z M205.134,52.218l0.658,4.637c0.324,2.246,1.52,4.261,3.339,5.619 c1.486,1.119,3.288,1.708,5.123,1.708c0.401,0,0.811-0.026,1.213-0.085l92.99-13.287c4.671-0.666,7.916-4.995,7.25-9.666 l-0.837-5.858c35.497,9.077,58.509,53.642,60.482,117.634c-32.021-10.477-73.214-16.634-119.35-16.634 c-43.797,0-83.051,5.593-114.312,15.123C149.895,109.609,165.129,76.836,205.134,52.218z M256.001,272.909 c-52.891,0-97.217-8.735-127.505-21.1c1.819-13.645,3.339-26.778,4.756-39.425c1.648-14.704,3.228-28.555,5.149-41.653 c29.724-10.341,70.208-17.368,117.6-17.368c100.641,0,170.781,31.5,170.781,59.773S356.642,272.909,256.001,272.909z"
      />
    </svg>
  );

export const WeTransferIcon =
  createSvgIcon(
    <svg
      viewBox="0 0 34 16"
    >
      <path
        d="M10.4136 11.9959C10.0873 11.4809 9.82024 11.2083 9.34554 11.2083C8.87085 11.2083 8.60383 11.4809 8.27748 11.9959L6.8534 14.2677C6.31937 15.1461 5.87434 15.752 4.83595 15.752C3.79755 15.752 3.32286 15.3279 2.8185 14.1465C2.19546 12.6926 1.54276 10.9357 0.949389 8.57293C0.296684 5.9371 0 4.30137 0 2.96855C0 1.63573 0.415357 0.848157 1.83944 0.575535C3.79755 0.212039 6.43804 0 9.34554 0C12.253 0 14.8935 0.212039 16.8516 0.575535C18.2757 0.848157 18.6911 1.63573 18.6911 2.96855C18.6911 4.30137 18.3944 5.9371 17.7417 8.57293C17.1483 10.9357 16.4956 12.6926 15.8726 14.1465C15.3682 15.3279 14.8935 15.752 13.8551 15.752C12.8167 15.752 12.3717 15.1461 11.8377 14.2677L10.4136 11.9959ZM32.9913 14.122C31.9826 15.2124 30.0838 16 27.5917 16C22.5777 16 19.6108 12.5165 19.6108 7.94252C19.6108 3.03532 23.0227 0.12735 27.4433 0.12735C31.3892 0.12735 34 2.21745 34 5.03455C34 7.70019 31.7749 9.42679 29.2531 9.42679C27.8883 9.42679 26.8796 9.15417 26.1972 8.60893C25.9302 8.39689 25.7819 8.42718 25.7819 8.66951C25.7819 9.66912 26.1379 10.5173 26.7906 11.1837C27.3246 11.7289 28.3334 12.0924 29.2828 12.0924C30.2618 12.0924 31.1222 11.8804 31.8936 11.4866C32.665 11.0928 33.3177 11.214 33.7034 11.8501C34.1484 12.5771 33.5254 13.5161 32.9913 14.122Z"
      />
    </svg>
  );


export const CircularPos2dIcon = (props) => {
  const { mode, anchored, moving, stationary } = props;

  const size = 100;   // Size of rasterisation
  const sw = 4;       // Stroke width of thickest elements
  const retLen = 6;  // Length of reticle arms

  function mapToCircle(p) {
    var { x, y } = p;
    // Constrain to circle
    var len2 = x * x + y * y;
    var len = Math.sqrt(len2);
    if (len > 1) {
      x = x / len;
      y = y / len;
      len = 1;
      len2 = 1;
    }

    // Non-linear mapping
    const z = Math.sqrt(1 - len2);
    const elevation = len2 > 1 ? 0 : Math.acos(Math.sqrt(len2));
    if (len > 0) {
      x = (x / len) * (1 - elevation / (Math.PI / 2));
      y = (y / len) * (1 - elevation / (Math.PI / 2));
    }
    return { x, y };
  }

  function Reticle(props) {
    const { x, y, width, stroke } = props;

    const { x: cx, y: cy } = mapToCircle({ x, y });
    const px = (cx + 1) / 2 * size + retLen;
    const py = (-cy + 1) / 2 * size + retLen;
    const angles = range(0, 359, 45).map(d => d * Math.PI / 180);
    const rc = retLen * 1.0;
    const r0 = retLen * 1.5;
    const r1 = retLen * 2.0;

    return (<>
      <circle
        cx={px}
        cy={py}
        r={rc}
        stroke={stroke}
        strokeWidth={width}
        fill='none'
      />
      {angles.map((a) => {
        return <line
          key={a}
          x1={px + r0 * Math.cos(a)}
          y1={py - r0 * Math.sin(a)}
          x2={px + r1 * Math.cos(a)}
          y2={py - r1 * Math.sin(a)}
          stroke={stroke}
          strokeWidth={width}
        />
      })}
    </>);
  }

  const c = size / 2 + retLen;
  return createSvgIcon(
    <svg viewBox={`0 0 ${size + retLen * 2} ${size + retLen * 2}`}>
      <line
        x1={retLen} y1={c} x2={size + retLen} y2={c}
        stroke={'grey'}
        strokeWidth={1}
      />
      <line
        x1={c} y1={retLen} x2={c} y2={size + retLen}
        stroke={'grey'}
        strokeWidth={1}
      />
      <circle
        cx={c}
        cy={c}
        r={size / 2 - sw / 2}
        stroke='black'
        strokeWidth={sw}
        fill='none'
      />
      {mode === 'moving' && anchored && stationary && stationary.map((p, i) => {
        return <Reticle key={i} x={p.x} y={p.y} width={sw / 2} stroke={'grey'} />
      })}
      {mode === 'moving' && moving && moving.map((p, i) => {
        return <Reticle key={i} x={p.x} y={p.y} width={sw / 2} stroke={'black'} />
      })}
      {mode === 'stationary' && stationary && stationary.map((p, i) => {
        return <Reticle key={i} x={p.x} y={p.y} width={sw / 2} stroke={'black'} />
      })}
    </svg>
  );
}


export const TriangleIcon = ({ size=5, color='#003fff' }) => {
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        borderLeft: `${size}px solid transparent`,
        borderRight: `${size}px solid transparent`,
        borderTop: `${size}px solid ${color}`,
        display: 'inline-block',
      }}
    />
  );
};
